import React from 'react';

export default function Rapp() {
  return (
    <svg viewBox="50 25 200 50" width="150" height="25">
      <g>
        <path
          d="M67.99,41.88c0-7.01-5.19-12.43-13.33-12.43H38.33v40.42h8.2V54.3h4.25l8.2,15.56h9.08l-8.96-16.53
        		C64.57,51.8,67.99,47.52,67.99,41.88z M53.13,47.52h-6.6V36.29h6.6c4.13,0,6.55,2.22,6.55,5.64
        		C59.68,45.24,57.26,47.52,53.13,47.52z"
        />
        <path
          d="M85.09,29.45L70.79,69.87h7.67l3.1-9.23H96.7l3.1,9.23h7.88L93.49,29.45H85.09z M83.98,53.45l5.15-15.28l5.15,15.28H83.98z
        		"
        />
        <path
          d="M127.63,29.45h-15.63v40.42h8.14V54.65h7.49c8.26,0,13.74-5.24,13.74-12.6C141.37,34.75,135.88,29.45,127.63,29.45z
        		 M126.62,47.86h-6.43V36.29h6.43c4.07,0,6.55,2.22,6.55,5.81C133.17,45.58,130.69,47.86,126.62,47.86z"
        />
        <path
          d="M164.29,29.45h-15.63v40.42h8.14V54.65h7.49c8.26,0,13.74-5.24,13.74-12.6C178.03,34.75,172.55,29.45,164.29,29.45z
        		 M163.28,47.86h-6.43V36.29h6.43c4.07,0,6.55,2.22,6.55,5.81C169.83,45.58,167.35,47.86,163.28,47.86z"
        />
        <rect x="187.83" y="28.9" width="42.15" height="40.96" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Rapp/index.js